module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="experience-name editable-container">\n    <div contenteditable="' +
__e(!spectatorMode) +
'" class="editable edit-name';
if(spectatorMode){;
__p += ' disabled';
};
__p += '" ';
if(spectatorMode){;
__p += 'disabled';
};
__p += '>\n    </div>\n</div>\n\n<div class="comments-current current-meta">\n    <div class="comments-indicator">\n        <div class="unread-comments-indicator-wrapper">\n            <div class="unread-comments-indicator"></div>\n        </div>\n    </div>\n</div>\n\n<div class="current-experience-status">\n    <i class="glyphicon glyphicon-exclamation-sign important not-pushed-changes-warning" data-content="The current version of this Experience is Not Pushed."></i>\n    <span class="pushed-check-mark">&#10003;</span>\n    <span class="readable-state"><span>\n</div>\n\n<div class="experience-preview-container">\n    <div class="experience-preview experience-container"></div>\n</div>\n\n';
 if (spectatorMode) { ;
__p += '\n<a href="#experience/' +
__e( id ) +
'/edit" class="view-experience pull-right btn btn-primary">View</a>\n';
 } else { ;
__p += '\n<a href="#experience/' +
__e( id ) +
'/edit" class="edit-experience pull-right btn btn-primary">Edit</a>\n';
 } ;
__p += '\n\n<a href="#" class="toggle-experience-url toggle-title\n    ';
 if (spectatorMode && !hasValidURL) { ;
__p += '\n    disabled" data-content="The direct Experience URL has not been enabled.\n    ';
 } else if (!hasValidURL) { ;
__p += '\n    disabled" data-content="To get a direct URL open your Experience and click Push.\n    ';
 } ;
__p += '\n    ">Experience URL</a>\n<div class="experience-url-container url-container"></div>\n<div class="experience-id-container">\n    <dl><dt>Experience ID</dt>\n        <dd class="experience-id-copy"\n            data-toggle     = "popover"\n            data-placement  = "bottom"\n            data-trigger    = "hover"\n            data-content    = "Click to copy.">' +
__e( id ) +
'</dd>\n    </dl>\n</div>\n<div class="work-by row">\n    <div class="col col-xs-6 created-by">\n        <label>Created by:</label>\n        <div>\n            <span class="author-name">' +
__e( createdBy ) +
'</span>\n            <span class="date">(' +
__e( humanDate(createdAt) ) +
')</span>\n        </div>\n    </div>\n    <div class="col col-xs-6 edited-by">\n        <label>Last Updated by:</label>\n        <div>\n            <span class="editor-name">' +
__e( editedBy ) +
'</span>\n            <span class="date">(' +
__e( humanDate(editedAt) ) +
')</span>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experienceOverview/QuickViewExperienceDetailsView.tpl
// module id = 2876
// module chunks = 0